import React from 'react'
import { ToleranceGroupDTO } from '../../../domain/DTO'
import { DeleteIcon } from '../../../icons'
import { getToleranceValueLimits, isInvalidToleranceValue } from './toleranceValidation'

type ToleranceFieldConfig = {
  label: string
  placeholder: string
  field: keyof ToleranceGroupDTO
}

type Props = {
  index: number
  toleranceGroupDTO: ToleranceGroupDTO
  toleranceFields: ToleranceFieldConfig[]
  onFieldChange: (index: number, field: keyof ToleranceGroupDTO, value: number | null) => void
  onDelete: (index: number) => void
}

export const EmptyToleranceGroupRow = ({ index, toleranceFields, onFieldChange, onDelete }: Props) => {
  const [localValues, setLocalValues] = React.useState<Record<string, number | null>>({})

  const handleInputChange = (field: keyof ToleranceGroupDTO, value: string) => {
    const numValue = value === '' ? null : Number(value)
    setLocalValues({ ...localValues, [field]: numValue ?? null })
    onFieldChange(index, field, numValue)
  }

  return (
    <div className="flex items-end gap-2">
      {toleranceFields.map((fieldConfig) => {
        const { minValue, maxValue } = getToleranceValueLimits(fieldConfig.field)

        return (
          <div className="inline-flex flex-col w-9 mt-1" key={fieldConfig.field}>
            <input
              name={fieldConfig.field}
              type="number"
              required
              min={minValue}
              max={maxValue}
              className={`border text-center rounded-r-[10px] mr-2 ${
                isInvalidToleranceValue(localValues[fieldConfig.field as string], fieldConfig.field)
                  ? '!border-red'
                  : ''
              }`}
              value={localValues[fieldConfig.field as string] ?? ''}
              onChange={(e) => handleInputChange(fieldConfig.field as keyof ToleranceGroupDTO, e.target.value)}
              placeholder={`${minValue} - ${maxValue}`}
            />
          </div>
        )
      })}
      <button type="button" className="pb-sm" title="Remove tolerance group row" onClick={() => onDelete(index)}>
        <DeleteIcon />
      </button>
    </div>
  )
}
